import Loading from '@/shared/components/Carregando';
import { BsSuitcaseLg } from 'react-icons/bs';
import { GetDashboardDefensores } from '@/modules/home/dashboards.service';
import { DataAmigavel } from '@/shared/utils/datas';
import { IconeDoTipoPeriodo } from '@/modules/business/periodo/Icones';
import { TipoPeriodoDescanso } from '../business/periodo/enums/tipo-periodo-descanso.enum';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { Dashboard } from '@/api.types';

export interface parametros {
  dia: Date;
  naovazio: boolean;
}

export default function TabelaResumo(props: parametros) {
  const [registros, setRegistros] = useState<Dashboard[]>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (props.dia) {
      GetDashboardDefensores(
        new Date(
          props.dia.getUTCFullYear(),
          props.dia.getUTCMonth(),
          props.dia.getUTCDate(),
        ),
        props.naovazio,
      )
        .then((result) => {
          setRegistros(result);
          setLoading(false);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }, [props]);

  function GetTitulo(item: Dashboard) {
    let titulo = item.defensor;
    if (item.motivo) titulo += ` - ${item.motivo}`;
    if (item.inicio)
      titulo += ` (${DataAmigavel(item.inicio)} a ${DataAmigavel(item.fim)})`;
    return titulo;
  }

  if (loading) return Loading();

  return (
    <>
      <div className="tabela table-responsive">
        <table className="table table-sm table-striped table-hover mt-5">
          <thead className="">
            <tr className="justify-content-center">
              <th scope="col">Defensor</th>
              <th scope="col">Situação</th>
            </tr>
          </thead>
          <tbody className="table-group-divider ">
            {registros &&
              registros.map((item, index) => {
                return (
                  <tr key={index} title={GetTitulo(item)}>
                    <td>{item.defensor}</td>
                    <td>{IconeDoTipoPeriodo(item.tipo)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="mt-4 table-responsive">
        <table className="table caption-top">
          <tbody>
            <tr>
              <td>
                <BsSuitcaseLg title="Trabalhando" /> Trabalhando
              </td>
              {/* <td>{IconeDoTipoPeriodo(TipoPeriodoDescanso.Afastamento)} Afastamento</td> */}
              <td>
                {IconeDoTipoPeriodo(TipoPeriodoDescanso.LicencaOutros)} Licença
                Outros
              </td>
              <td>
                {IconeDoTipoPeriodo(TipoPeriodoDescanso.LicencaPremio)} Licença
                Prêmio
              </td>
            </tr>
            <tr>
              <td>
                {IconeDoTipoPeriodo(TipoPeriodoDescanso.AbonoEspecial)} Abono
                Especial
              </td>
              <td>
                {IconeDoTipoPeriodo(TipoPeriodoDescanso.AbonoTrabalhado)} Abono
                Trabalhado
              </td>
              <td>
                {IconeDoTipoPeriodo(TipoPeriodoDescanso.FolgaNatalicia)} Folga
                Natalícia
              </td>
              <td>{IconeDoTipoPeriodo(TipoPeriodoDescanso.Ferias)} Férias</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
